<!-- Dati riassuntivi monitoraggio -->
<mat-card class="align-items-center">
    <mat-card-header class="text-center pb-3">
        <mat-card-title>Monitoraggio</mat-card-title>
<!--         <mat-card-subtitle class="mt-3">
            <span class="main-font">{{ gameData.position + '°' }}</span>
        </mat-card-subtitle> -->
    </mat-card-header>
    <mat-card-content class="align-self-start col-12">
<!--         <div class="d-flex justify-content-center text-center pt-4 pb-custom">
            <div *ngFor="let achievement of gameData.last_achievements" class="col-4">
                <img [src]="achievement.image_path" alt="Achievement" class="last-achievement" [matTooltip]="achievement.title" matTooltipPosition="above">
            </div>
        </div> -->
        <div class="text-center p-custom">
            <!-- <img width="100" height="100" src="https://img.icons8.com/ios/100/question-mark--v1.png" alt="question-mark--v1"/> -->
            <img width="200" height="200" src="https://img.icons8.com/external-bearicons-detailed-outline-bearicons/200/00337C/external-Coming-Soon-miscellany-texts-and-badges-bearicons-detailed-outline-bearicons.png" alt="external-Coming-Soon-miscellany-texts-and-badges-bearicons-detailed-outline-bearicons"/>
        </div>
        <button mat-raised-button color="accent" class="col-12 mon-button">Vai a monitoraggio</button>
    </mat-card-content>
</mat-card>
